// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AuditLocationProperty } from '@/audit/api/types';
import { AuditPropertyValue } from '@/audit/components/audit-property-value';
import { ArrowForwardRounded } from '@/constants/hardfin-standard-icons';
import { Tooltip, Typography } from '@mui/material';

interface Props {
  property: AuditLocationProperty;
}

export function AuditLocationLabel(props: Props) {
  const newValue = props.property.newValue?.name ?? null;
  const newValueTooltip =
    props.property.newValue?.metadata?.address?.formattedAddress ?? null;

  if (props.property.oldValue === undefined) {
    return (
      <Typography display="flex" variant="caption" alignItems="center">
        <Typography component="span" variant="inherit" fontWeight="bold">
          {props.property.name}:&nbsp;
        </Typography>
        <Tooltip arrow title={newValueTooltip}>
          <AuditPropertyValue
            value={newValue}
            sx={{
              textDecoration: newValueTooltip === null ? 'none' : 'underline',
              textDecorationStyle: 'dotted',
            }}
          />
        </Tooltip>
      </Typography>
    );
  }

  const oldValue = props.property.oldValue?.name ?? null;
  const oldValueTooltip =
    props.property.oldValue?.metadata?.address?.formattedAddress ?? null;

  return (
    <Typography display="flex" variant="caption" alignItems="center">
      <Typography component="span" variant="inherit" fontWeight="bold">
        {props.property.name}:&nbsp;
      </Typography>
      <Tooltip arrow title={oldValueTooltip}>
        <AuditPropertyValue
          value={oldValue}
          sx={{
            textDecoration: oldValueTooltip === null ? 'none' : 'underline',
            textDecorationStyle: 'dotted',
          }}
        />
      </Tooltip>
      <ArrowForwardRounded fontSize="inherit" sx={{ marginX: 1 }} />
      <Tooltip arrow title={newValueTooltip}>
        <AuditPropertyValue
          value={newValue}
          sx={{
            textDecoration: newValueTooltip === null ? 'none' : 'underline',
            textDecorationStyle: 'dotted',
          }}
        />
      </Tooltip>
    </Typography>
  );
}
